import ReactGA from 'react-ga4';

const MEASUREMENT_ID = 'G-R238ZHZ6HR'; // Replace with your ID

let initialized = false;

export const initGA = () => {
  if (!initialized) {
    ReactGA.initialize(MEASUREMENT_ID);
    initialized = true;
  }
};

export const logPageView = (path) => {
  const consent = localStorage.getItem('rtk-cookie-consent');
  if (consent === 'accepted') {
    if (!initialized) initGA();
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

export const logEvent = (category, action, label) => {
  const consent = localStorage.getItem('rtk-cookie-consent');
  if (consent === 'accepted') {
    if (!initialized) initGA();
    ReactGA.event({
      category,
      action,
      label,
    });
  }
};

export const logPurchase = (transactionId, value, items) => {
  const consent = localStorage.getItem('rtk-cookie-consent');
  if (consent === 'accepted') {
    if (!initialized) initGA();
    ReactGA.event('purchase', {
      transaction_id: transactionId,
      value: value,
      currency: 'USD',
      items: items,
    });
  }
};

export const logAddToCart = (item) => {
  const consent = localStorage.getItem('rtk-cookie-consent');
  if (consent === 'accepted') {
    if (!initialized) initGA();
    ReactGA.event('add_to_cart', {
      currency: 'USD',
      value: item.price,
      items: [{
        item_id: item.id,
        item_name: item.name,
        price: item.price,
        quantity: item.quantity || 1,
      }],
    });
  }
};

export const logBeginCheckout = (value, items) => {
  const consent = localStorage.getItem('rtk-cookie-consent');
  if (consent === 'accepted') {
    if (!initialized) initGA();
    ReactGA.event('begin_checkout', {
      currency: 'USD',
      value: value,
      items: items,
    });
  }
};